// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2-ngj","inputDescription":"styles_inputDescription__1RWvY"};